/**
 * Check if an element is visible.
 * It recursively checks all parents until the passed parent element is reached.
 */
export const checkElementVisibility = (element: HTMLElement, parent: HTMLElement | null = null) => {
  if ('checkVisibility' in element && typeof element.checkVisibility === 'function') {
    return element.checkVisibility()
  }

  const defaultView = element.ownerDocument.defaultView
  if (!defaultView) {
    return false
  }

  let currentElement: HTMLElement | null = element
  while (currentElement && currentElement !== parent) {
    if (currentElement.hasAttribute('hidden')) {
      return false
    }

    const computedStyle = defaultView.getComputedStyle(currentElement)
    if (
      computedStyle.display === 'none' ||
      computedStyle.visibility === 'hidden' ||
      computedStyle.visibility === 'collapse' ||
      computedStyle.opacity === '0'
    ) {
      return false
    }

    currentElement = currentElement.parentElement
  }

  return true
}
